import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

import LanguageSwitcher from './LanguageSwitcher';
import BecomeExhibitorButton from '../../components/BecomeExhibitorButton';
import Navigation_ from './Navigation';
import MobileNavigation_ from './MobileNavigation';
import Link from '../../components/Link';
import { breakpoints } from '../../constants';

import background from '../assets/header-background.jpg';
import backgroundMob from '../assets/header-background-mob.jpg';
import logo from '../assets/logo.svg';
import organizedBy from '../assets/organized-by.png';

const HeaderSection = styled.section`
    background: url(${background}) center center no-repeat no-repeat;
    background-size: cover;
    height: 730px;
    position: relative;

    @media (max-width: ${breakpoints.tablet}) {
        background: url(${backgroundMob}) center center no-repeat no-repeat;
        background-size: cover;
        margin-bottom: 150px;
        height: 680px;
        &:after {
            display: block;
            position: absolute;
            top: 100%;
            content: '';
            background: url(${organizedBy}) center center no-repeat no-repeat;
            background-size: 70%;
            height: 150px;
            width: 100vw;
        }
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-bottom: 100px;
        height: 400px;
        &:after {
            height: 100px;
            background-size: 80%;
        }
    }
`;

const Logo = styled.a`
    background: url(${logo}) no-repeat;
    background-size: contain;
    display: inline-block;
    width: 211px;
    height: 214px;
    margin-left: 238px;
    margin-top: 70px;

    @media (max-width: ${breakpoints.tablet}) {
        display: none;
    }
`;

const LogoMob = styled.a`
    display: none;
    @media (max-width: ${breakpoints.tablet}) {
        background: url(${logo}) no-repeat;
        background-size: contain;
        display: inline-block;
        width: 60px;
        height: 60px;
        margin-left: 40px;
        margin-top: 12px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        margin-left: 20px;
    }
`;

const Dates = styled.div`
    position: absolute;
    top: 335px;
    left: 320px;
    font-size: 1.42rem;
    text-align: center;
    color: #003056;
    font-weight: bold;

    @media (max-width: ${breakpoints.tablet}) {
        color: white;
        top: 150px;
        left: 40px;
        font-size: 2rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 1.3rem;
        top: 120px;
        left: 20px;
    }
`;

const Numbers = styled.div`
    color: #20bbef;
    font-size: 3.5rem;
    line-height: 3.5rem;
    font-weight: normal;

    @media (max-width: ${breakpoints.tablet}) {
        color: white;
        font-size: 4.5rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 3rem;
    }
`;

const Place = styled.div`
    font-size: 80%;
`;

const OrganizedBy = styled.img`
    position: absolute;
    top: 560px;
    left: 367px;

    @media (max-width: ${breakpoints.tablet}) {
        display: none;
    }
`;

const Slogan = styled.div`
    position: absolute;
    font-size: 2.3rem;
    text-align: right;
    color: white;
    text-transform: uppercase;
    right: 200px;
    top: 267px;

    span {
        display: inline-block;
        border: 1px solid white;
        padding: 4px 5px 0;
        line-height: 100%;
    }

    @media (max-width: ${breakpoints.tablet}) {
        top: 420px;
        right: 40px;
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 5vw;
        top: 260px;
        right: 20px;
    }
`;

const StyledBecomeExhibitorButton = styled(BecomeExhibitorButton)`
    position: absolute;
    right: 200px;
    top: 556px;
`;

const StyledRegistrationButton = styled(Link)`
    position: absolute;
    right: 200px;
    top: 615px;
`;

const NavigationWrapper = styled.div`
    position: absolute;
    top: 70px;
    right: 200px;
    display: flex;

    @media (max-width: ${breakpoints.tablet}) {
        position: initial;
        display: flex;
        align-items: center;
        width: 100%;
        height: 80px;
        background-color: white;
    }
`;

const LanguageSwitcherWrapper = styled.div`
    position: absolute;
    top: 20px;
    right: 200px;
    @media (max-width: ${breakpoints.tablet}) {
        right: 80px;
        top: 30px;
        a {
            color: #003056 !important;
        }
    }
`;

const Navigation = styled(Navigation_)`
    @media (max-width: ${breakpoints.tablet}) {
        display: none;
        margin-left: 30px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        display: none;
    }
`;

const MobileNavigation = styled(MobileNavigation_)`
    display: none;
    margin-left: auto;
    @media (max-width: ${breakpoints.tablet}) {
        display: initial;
    }
`;

class Header extends React.Component {
    render() {
        const { langs, intl } = this.props;

        return (
            <HeaderSection>
                <NavigationWrapper>
                    <LogoMob />
                    <Navigation header />
                    <MobileNavigation />
                </NavigationWrapper>
                <LanguageSwitcherWrapper>
                    <LanguageSwitcher langs={langs} />
                </LanguageSwitcherWrapper>
                <Logo />
                <Dates>
                    <Numbers>12•13•14</Numbers>
                    <div>
                        <FormattedMessage id="header.dates.date" />
                    </div>
                    <Place>
                        <FormattedMessage id="header.dates.place" />
                    </Place>
                </Dates>
                <OrganizedBy src={organizedBy} />

                <Slogan
                    dangerouslySetInnerHTML={{
                        __html: intl.formatHTMLMessage({ id: 'header.slogan' }),
                    }}
                />
                {/* <StyledBecomeExhibitorButton
                    label={intl.formatMessage({ id: 'header.button' })}
                />
                <StyledRegistrationButton
                    to="pages/registration"
                    className="button"
                >
                    {intl.formatHTMLMessage({
                        id: 'header.registrationButton',
                    })}
                </StyledRegistrationButton> */}
            </HeaderSection>
        );
    }
}

export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/layouts/components/IndexHeader.js